import { render, staticRenderFns } from "./AppBreadcrumb.vue?vue&type=template&id=877a52e2&scoped=true&"
import script from "./AppBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./AppBreadcrumb.vue?vue&type=script&lang=js&"
import style0 from "./AppBreadcrumb.vue?vue&type=style&index=0&id=877a52e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "877a52e2",
  null
  
)

export default component.exports